import { Inject, Injectable } from "@angular/core";
import { EndLink, Link, Transmission } from "../links.model";
import { DeviceLinkModel, EndPortLink } from "../modal-wizard/steps/1-devices/link-device-model";
import { GeneralLinkModel } from "../modal-wizard/steps/2-general/link-general-model";
import { MANAGEMENT_DEVICE_REST_SERVICE } from "@nms-ng2/app/shared/services/upgraded-provider/upgraded-providers";
import { NmsWizardStepMapData } from "@nms-angular-toolkit/nms-wizard";

/**
 * Utilitário para tratar dados dos links.
 */
@Injectable({
    providedIn: "root"
})
export class LinkStepModelsUtilsService {

    constructor(@Inject(MANAGEMENT_DEVICE_REST_SERVICE) private readonly managementDeviceRestService: any) {}

    async buildDeviceLinkModel(link: Link): Promise<DeviceLinkModel> {
        const model: DeviceLinkModel = new DeviceLinkModel();
        const applyAEnd = (endPortLink: EndPortLink) => {
            model.aEndLink = endPortLink;
        };
        const applyZEnd = (endPortLink: EndPortLink) => {
            model.zEndLink = endPortLink;
        };
        const aEndPromise = this.getEndDevice(link.aEnd, applyAEnd);
        if (link.zEnd) {
            const zEndPromise = this.getEndDevice(link.zEnd, applyZEnd);
            await Promise.all([aEndPromise, zEndPromise]);
        } else {
            await aEndPromise;
        }
        model.linkId = link.id;

        return model;
    }

    async buildGeneralLinkModel(link: Link): Promise<GeneralLinkModel> {
        return {
            id: link.id,
            name: link.name,
            linkType: link.typeId,
            distance: link.distance,
            attenuation: link.attenuation,
            description: link.description,
            weight: link.weight,
            generatedName: link.generateName,
        } as GeneralLinkModel
    }

    public buildLink(wizardStepsCacheMap: NmsWizardStepMapData): Link {
        const deviceLinkModel = wizardStepsCacheMap["DeviceLinkModel"] as DeviceLinkModel;
        const generalLinkModel = wizardStepsCacheMap["GeneralLinkModel"] as GeneralLinkModel;
        const link: Link = new Link();
        link.aEnd = this.buildEnd(deviceLinkModel.aEndLink, deviceLinkModel.isDwdm);
        link.zEnd = this.buildEnd(deviceLinkModel.zEndLink, deviceLinkModel.isDwdm);

        link.id = generalLinkModel.id;
        link.name = generalLinkModel.name || "";
        link.typeId = generalLinkModel.linkType;
        link.weight = generalLinkModel.weight;
        link.description = generalLinkModel.description || "";
        link.generateName = generalLinkModel.generatedName || false;
        link.attenuation = generalLinkModel.attenuation;
        link.distance = generalLinkModel.distance;

        return link;
    }

    public buildEnd(endPortLink: EndPortLink, isDwdm: boolean): EndLink {
        const endLink = new EndLink();

        endLink.deviceResourceId = endPortLink.endResourceId;
        endLink.transmission = isDwdm ? endPortLink.endTransmission : Transmission.NONE;

        if (endPortLink.muxDemux) {
            endLink.muxDemux = endPortLink.muxDemux;
            endLink.muxDemuxResourceId = endPortLink.endMuxResourceId;
        } else {
            endLink.chassisNo = endPortLink.endChassisNo;
            endLink.slotNo = endPortLink.endSlotId;
            endLink.portNo = endPortLink.endPortNo;
            endLink.portModel = endPortLink.endPortModelId;
        }

        return endLink;
    }

    private async getEndDevice(endLink: EndLink, callback): Promise<void> {
        const device = await this.managementDeviceRestService.findDeviceById(endLink.deviceResourceId);
        const endPortLink: EndPortLink = new EndPortLink();

        endPortLink.endDeviceName = device.name;
        endPortLink.endResourceId = device.id;
        endPortLink.endDeviceModel = device.model;
        endPortLink.endDeviceModelCode = device.modelCode;
        endPortLink.endSlotId = endLink.slotNo;
        endPortLink.endChassisNo = endLink.chassisNo;
        endPortLink.endPortNo = endLink.portNo;
        endPortLink.endPortModelId = endLink.portModel;
        endPortLink.muxDemux = endLink.muxDemux;
        endPortLink.endMuxResourceId = endLink.muxDemuxResourceId;
        endPortLink.endTransmission = endLink.transmission;
        endPortLink.endDevice = device;

        callback(endPortLink);
    }

}
